import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
    Grid,
    IconButton,
    Stack
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import {
    Table,
    Column,
    CommonModal,
    Select,
    PrimaryButton
} from '../Common';

import Routes from '../../routes';
import UserInfo from '../../UserInfo';
import User from '../Account/User';

const Providers = ({
    id,
}) => {
    const [dataRefresh, setDataRefresh] = useState(crypto.randomUUID());
    const [isVisible, setVisible] = useState(false);

    const [locationOptions, setLocationOptions] = useState([]);
    const [location, setLocation] = useState(null);
    const [locationHasError, setLocationHasError] = useState(false);

    const onVisibleChangeState = () => setVisible(prev => !prev);

    const onRevokeLocation = async (row) => {
        const response = await fetch(Routes.Location.RevokeServiceProvider(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                servicerInstanceId: row.id,
                locationId: id,
            })
        });

        if (response.status === 200) {
            setDataRefresh(crypto.randomUUID());
            toast.success('The service provider has been successfully revoked from this location.', { duration: 6000 });
        }
    }

    const onSubmit = async () => {

        if (!location) {
            setLocationHasError(true);
            return;
        }

        const response = await fetch(Routes.Location.AssignServiceProvicer(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                servicerInstanceId: location,
                locationId: id,
            })
        });

        if (response.status === 200) {
            setLocation(null);
            setLocationHasError(false);
            setDataRefresh(crypto.randomUUID());
            onVisibleChangeState();
            toast.success('The service provider has been successfully assigned to this location.', { duration: 6000 });
        }
    }

    const fetchAvailableProviders = useCallback(async () => {
        const response = await fetch(Routes.Location.GetAvailableServiceProvider(id));
        const data = await response.json();
        console.log({
            servicerInstanceNavigation: data.map(x => x.servicerInstanceNavigation)
        });

        const filteredData = data.map(x => x.servicerInstanceNavigation);

        if (filteredData) {
            setLocationOptions(
                filteredData.map(x => ({
                    id: x.id,
                    name: x.name
                }))
            );
        }
    }, [id, dataRefresh])

    useEffect(() => {
        fetchAvailableProviders();
    }, [fetchAvailableProviders])

    return (
        <>
            <Grid
                container
                direction="row"
                sx={{
                    marginTop: "-1.2%"
                }}
                style={{ maxWidth: '55%' }}
            >
                <Grid item xs={12} lg={12} pt={2}>
                    <Table
                        url={Routes.Location.ServiceProviderTable(id)}
                        refresh={dataRefresh}
                        tableHeader="Service Providers"
                        tableHeaderTooltipText=""
                        noResultText="Oops...It is empty here..."
                        noResultText2="Add a new Service Provider to get started."
                        {
                            ...((UserInfo.isNativeSystemOwner() && (UserInfo.isSystemAdministrator() || UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator())) && {
                                    MUIButtonOnClick: onVisibleChangeState,
                                    MUIButtonText: "Assign Service Provider"
                                }
                            )
                        }
                    >
                        <Column id='IDHeader' title="ID" property="id" linkId="id" />
                        <Column id='NameHeader' title="NAME" property="name" />
                        <Column id='GrantTypeHeader' title="GRANT TYPE" property="grant" />
                        <IconButton
                            MUIIcon
                            toolTip="Revoke"
                            onClick={(_, row) => onRevokeLocation(row)}
                            isVisible={(row) => row.grant === "Specific Location" && (UserInfo.isSystemAdministrator() || UserInfo.isNativeUser())}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Table>
                </Grid>
            </Grid >


            <CommonModal
                header="Assign Service Provider"
                open={isVisible}
                close={() => {
                    onVisibleChangeState();
                    setLocation(null);
                    setLocationHasError(false);
                }}
            >
                <Stack
                    sx={{
                        width: "501px",
                        height: "170px",
                        gap: "25px",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px"
                    }}
                >
                    <Select
                        required
                        variant="standard"
                        label="Service Provider"
                        value={location}
                        options={locationOptions}
                        error={locationHasError}
                        onChange={e => {
                            setLocation(e.target.value);
                            if (e.target.value !== "") {
                                setLocationHasError(false);
                            }
                        }}
                        width={70} />
                    <PrimaryButton
                        useLargeButton
                        width={70}
                        buttonText="Assign"
                        onClick={onSubmit}
                    />
                </Stack>
            </CommonModal>
        </>
    )
};

export default Providers;
